import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import introJs from 'intro.js';
import { PostHog } from 'posthog-js';

import 'intro.js/introjs.css';

const RESULT_TOUR_STRINGS = appStrings.tours.results;

export const RESULT_PAGE_TOUR_IDS = {
  step1: 'aspirations-container',
  step2: 'minimum-track-explanation-container',
  step3: 'career-path-diagram-container',
  step4: 'suggested-career-paths-container',
  step5: 'career-path-dialog-container',
  step6: 'career-path-dialog-container-lubav',
  step7: 'markers-of-success-container',
  step8: 'markers-of-success-container',
  step9: 'result-actions-container',
} as const;

export const startResultPageTour = ({
  setExpandedMarkersOfSuccessIndex,
  onFinishOrSkipTour,
  setIsCareerPathDialogOpen,
  onStartOfTour,
  postHog,
  start_type,
  user_id,
}: {
  setExpandedMarkersOfSuccessIndex: (index: number | null) => void;
  onFinishOrSkipTour: () => void;
  setIsCareerPathDialogOpen: (isOpen: boolean) => void;
  onStartOfTour: () => void;
  postHog: PostHog;
  start_type: 'FIRST_TIME' | 'RESTART';
  user_id?: number;
}) => {
  const style = document.createElement('style');

  style.innerHTML = `
    .career-path-dialog-first-step {
      top: 15% !important;
    }
    @media (min-width: 400px) {
      .career-path-dialog-first-step {
        top: 10% !important;
      }
    }
  `;
  document.head.appendChild(style);

  const tour = introJs();

  tour
    .setOptions({
      showBullets: false,
      exitOnOverlayClick: false,
      showStepNumbers: true,
      skipLabel: 'Skip',
      steps: [
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step1}`,
          intro: RESULT_TOUR_STRINGS.step1,
          scrollTo: 'tooltip',
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step2}`,
          intro: RESULT_TOUR_STRINGS.step2,
          scrollTo: 'tooltip',
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step3}`,
          intro: RESULT_TOUR_STRINGS.step3,
          position: 'right',
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step4}`,
          intro: RESULT_TOUR_STRINGS.step4,
          scrollTo: 'tooltip',
          position: 'left',
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step5}`,
          tooltipClass: 'career-path-dialog-first-step',
          position: 'floating',
          intro: RESULT_TOUR_STRINGS.step5,
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step6}`,
          position: 'bottom',
          intro: RESULT_TOUR_STRINGS.step6,
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step7}`,
          intro: RESULT_TOUR_STRINGS.step7,
          position: 'right',
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step8}`,
          intro: RESULT_TOUR_STRINGS.step8,
        },
        {
          element: `#${RESULT_PAGE_TOUR_IDS.step9}`,
          intro: RESULT_TOUR_STRINGS.step9,
        },
      ],
    })
    .onbeforechange(function () {
      onStartOfTour();

      document.body.style.overflow = 'hidden'; // Prevent scrolling during each step

      const skipButton = document.querySelector('.introjs-skipbutton') as HTMLElement;

      const currentStep = this._currentStep;

      // show the career path dialog on step 4 and 5
      setIsCareerPathDialogOpen([4, 5].includes(currentStep));

      if (skipButton) {
        skipButton.style.display = currentStep === 0 ? 'inline' : 'none'; // Show "Skip" on the first step
      }

      if (currentStep === 7) {
        setExpandedMarkersOfSuccessIndex(0);

        return true;
      }

      setExpandedMarkersOfSuccessIndex(null);

      postHog.capture('tour_blueprint', {
        tour_name: 'result_page',
        action: 'step',
        direction: this._direction,
        step: this._currentStep,
        start_type,
        user_id: `${user_id}` || 'unauthenticated',
      });

      return true;
    })
    .onskip(function () {
      setExpandedMarkersOfSuccessIndex(null);
      setIsCareerPathDialogOpen(false);

      onFinishOrSkipTour();

      postHog.capture('tour_blueprint', {
        tour_name: 'result_page',
        action: 'skip',
        step: this._currentStep,
        start_type,
        user_id: `${user_id}` || 'unauthenticated',
      });
    })
    .onexit(function () {
      setExpandedMarkersOfSuccessIndex(null);
      setIsCareerPathDialogOpen(false);

      onFinishOrSkipTour();
    })
    .oncomplete(function () {
      postHog.capture('tour_blueprint', {
        tour_name: 'result_page',
        action: 'complete',
        step: this._currentStep,
        start_type,
        user_id: `${user_id}` || 'unauthenticated',
      });
    })
    .start();
};
